// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__8WywC","red":"Preview_red__s00ZU","orange":"Preview_orange__PpRZx","green":"Preview_green__uoob-"};